import React from 'react';
import Icon from './Icon';

const NAVY = '#0e2340';
const GOLD = '#c48a3a';

// DemoHub — eenvoudige ingang naar de drie demo-ervaringen (web-only hulppagina).
export default function DemoHub() {
  const links = [
    {
      href: '/app-demo',
      icon: 'play',
      title: 'Interactieve demo',
      desc: 'Klik zelf door de app — kies alleen of samen en ervaar match, ijsberg, woonreis, Wooncoach en partners.',
      tag: 'ZELF ONTDEKKEN',
      testid: 'hub-link-app-demo',
    },
    {
      href: '/go/demo?mode=solo&autoplay=1&v=2',
      icon: 'user',
      title: 'Rondleiding · Solo',
      desc: 'De automatische Ghost Driver-rondleiding door de app als solo-zoeker (Sofie).',
      tag: 'AUTO-DEMO · 2.0',
      testid: 'hub-link-ghost-solo',
    },
    {
      href: '/go/demo?mode=couple&autoplay=1&v=2',
      icon: 'users',
      title: 'Rondleiding · Samen',
      desc: 'De automatische Ghost Driver-rondleiding als koppel (Tom & Emma) — met koppelmatch en gedeelde agenda.',
      tag: 'AUTO-DEMO · 2.0',
      testid: 'hub-link-ghost-couple',
    },
    {
      href: '/iceberg',
      icon: 'chevrons-down',
      title: 'IJsbergmethode',
      desc: 'Waarom IMMO MATCH andere matches vindt dan klassieke woningsites — drie lagen diep.',
      tag: 'INTERACTIEF',
      testid: 'hub-link-iceberg',
    },
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(180deg, #0e2340, #050a14)', padding: '40px 20px 60px' }} data-testid="demo-hub">
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 28 }}>
          <img src="/logo_official.png" alt="IMMO MATCH logo" style={{ width: 52, height: 52, objectFit: 'contain' }} />
          <div>
            <div style={{ color: '#fff', fontSize: 20, fontWeight: 900, letterSpacing: 1.2 }}>
              IMMO<span style={{ color: GOLD, fontStyle: 'italic', fontWeight: 400 }}>match</span>{' '}
              <span style={{ color: GOLD, fontSize: 9, fontWeight: 900, letterSpacing: 1.3 }}>DEMO</span>
            </div>
            <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, marginTop: 2 }}>Jouw persoonlijke Wooncoach — nu in je browser</div>
          </div>
        </div>

        <div style={{ color: GOLD, fontSize: 10, fontWeight: 900, letterSpacing: 1.4, marginBottom: 8 }}>WEB-DEMO · GEEN INSTALLATIE NODIG</div>
        <h1 style={{ color: '#fff', fontSize: 30, fontWeight: 900, letterSpacing: -0.5, lineHeight: '38px', margin: '0 0 10px' }}>
          Ervaar IMMO MATCH zonder app of account.
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, lineHeight: '21px', margin: '0 0 28px' }}>
          Kies hieronder hoe je de demo wil bekijken. Alles draait met fictieve demo-data — er wordt niets opgeslagen over jou.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testid} style={{ textDecoration: 'none' }}>
              <div style={{
                background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.10)',
                borderRadius: 18, padding: 18, display: 'flex', gap: 14, alignItems: 'flex-start',
                transition: 'border-color .2s ease, background .2s ease',
              }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(196,138,58,0.5)'; e.currentTarget.style.background = 'rgba(196,138,58,0.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.10)'; e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
              >
                <div style={{ width: 42, height: 42, borderRadius: 21, background: 'rgba(196,138,58,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Icon name={l.icon} size={18} color={GOLD} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ color: GOLD, fontSize: 9, fontWeight: 900, letterSpacing: 1.3, marginBottom: 4 }}>{l.tag}</div>
                  <div style={{ color: '#fff', fontSize: 16, fontWeight: 900 }}>{l.title}</div>
                  <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12.5, lineHeight: '18px', marginTop: 4 }}>{l.desc}</div>
                </div>
                <Icon name="arrow-right" size={16} color={GOLD} style={{ marginTop: 4, flexShrink: 0 }} />
              </div>
            </a>
          ))}
        </div>

        <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 11, fontStyle: 'italic', marginTop: 28, textAlign: 'center' }}>
          Demo met fictieve data. Geen registratie, geen echte woningen, geen echte e-mails.
        </div>
      </div>
    </div>
  );
}
